import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BankState } from "../../../types";
import { axiosObj } from "../../../../config/apiClients";
import { Bank } from "../../../../utils/types";

const initialState: BankState = {
  isLoading: false,
  banks: [],
  bank: null,
}

export const getAllBanks = createAsyncThunk(
  "/banks/getAll",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosObj.get("/banks/getAll");
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to Fetch Banks' });
    }
  }
)

export const createBank = createAsyncThunk(
  "/banks/create",
  async (bank: Bank, { rejectWithValue }) => {
    try {
      const response = await axiosObj.post('/banks/create', bank);
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to Add Bank' });
    }
  }
)

export const updateBank = createAsyncThunk(
  "/banks/update",
  async (bank: Bank, { rejectWithValue }) => {
    try {
      const response = await axiosObj.patch('/banks/update', bank);
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to Update Bank' });
    }
  }
)

export const deleteBank = createAsyncThunk(
  "/banks/delete",
  async (bankId: string, { rejectWithValue }) => {
    try {
      const response = await axiosObj.delete('/banks/delete', { data: { bankId } });
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to delete Bank' });
    }
  }
)

const bankSlice = createSlice({
  name: "bank",
  initialState,
  reducers: {
    setBank: (state, action) => {
      state.bank = action.payload;
    },
    removeBank: (state, action) => {
      const bankId = action.payload;
      state.banks = state.banks.filter((bank) => bank._id !== bankId);
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllBanks.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllBanks.fulfilled, (state, action) => {
        state.isLoading = false;
        state.banks = action.payload.payload.allBanks;
      })
      .addCase(getAllBanks.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(createBank.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createBank.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(createBank.rejected, (state) => {
        state.isLoading = false;
      })
    .addCase(updateBank.pending, (state) => {
      state.isLoading = true;
    })
    .addCase(updateBank.fulfilled, (state) => {
      state.isLoading = false;
    })
    .addCase(updateBank.rejected, (state) => {
      state.isLoading = false;
    })
    .addCase(deleteBank.pending, (state) => {
      state.isLoading = true;
    })
    .addCase(deleteBank.fulfilled, (state) => {
      state.isLoading = false;
    })
    .addCase(deleteBank.rejected, (state) => {
      state.isLoading = false;
    });
  }
});

export const { setBank, removeBank } = bankSlice.actions;

export default bankSlice.reducer;